import { Node, mergeAttributes } from '@tiptap/core';
export const Format = Node.create({
    name: 'format',
    group: 'block',
    draggable: true,
    atom: true,
    addAttributes() {
        return {
            formats: {
                default: [],
                renderHTML(attrs) {
                    return { 'data-formats': attrs.formats.join(',') };
                },
                parseHTML(element) {
                    const formats = element.getAttribute('data-formats');
                    return formats?.split(',') ?? [];
                },
            },
        };
    },
    addCommands() {
        return {
            setFormat: () => ({ commands }) => {
                return commands.insertContent({ type: this.name });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mb-format',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['mb-format', mergeAttributes(HTMLAttributes)];
    },
});
//# sourceMappingURL=format.js.map